import React, { useEffect } from "react";
import commonStyles from "@styles/CommonEditorPageLayout.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Button from "@components/buttons/Button/Button";
import { useAuth } from "@context/auth-context";
import { trackEvent } from "@util/ga";
import styles from "./PurchaseSuccessPage.module.css";

const PurchaseSuccessPage: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const purchaseType = searchParams.get("purchaseType");
    const singleCredit = searchParams.get("singleCredit") === "true";
    const { authState, refreshUser } = useAuth();

    useEffect(() => {
        // Only track conversions for standard users
        if (authState.user?.userType === "standard_user") {
            const value = purchaseType === "candle" ? 0 : process.env.REACT_APP_MEMORIAL_PRICE_STANDARD;
            trackEvent("purchase", {
                value,
                currency: "AUD",
            });
        }
    }, []);

    // Get updated user data
    useEffect(() => {
        void refreshUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleFinish = async () => {
        if (purchaseType === "subscription") {
            navigate("/upcoming-services", { replace: true });
        } else {
            await navigate("/memorials", { replace: true });
            if (singleCredit) {
                navigate("/memorials/editor?mode=add");
            }
        }
    };

    let message = "Success";
    let buttonText = "Begin";
    if (purchaseType === "subscription") {
        message = "Begin curating your online experience now!";
    } else if (purchaseType === "memorialCredits") {
        message = "Begin personalising your memorial now!";
    } else if (purchaseType === "candle") {
        message = "Your Forever Candle order was successful! Please check your email for order updates.";
        buttonText = "Finish";
    }

    return (
        <div className={commonStyles.container}>
            <h2>Purchase Successful!</h2>
            <div className={commonStyles.messageContainer}>
                <div className={styles.checkIcon}>
                    <CheckCircleOutlineIcon fontSize="inherit" />
                </div>
                <p>{message}</p>
                <div className={styles.buttonContainer}>
                    <Button onClick={handleFinish}>{buttonText}</Button>
                </div>
            </div>
        </div>
    );
};

export default PurchaseSuccessPage;
